import { useBrokerDetailsStore } from '../../state/brokerDetailsStore';
import { SameAsContactAddressField } from './components/SameAsContactAddressField';
import { StreetAddressField } from './components/StreetAddressField';
import { StreetAddress2Field } from './components/StreetAddress2Field';
import { CityField } from './components/CityField';
import { StateField } from './components/StateField';
import { ZipCodeField } from './components/ZipCodeField';
import { ShowIf } from '@apply/ui';

export const HomeAddressSection = () => {
    const sameAsContactAddress = useBrokerDetailsStore((s) => s.sameAsContactAddress);

    return (
        <>
            <h2 className='decorated'>Home Address</h2>
            <div>
                <SameAsContactAddressField />
            </div>
            <ShowIf showIf={!sameAsContactAddress}>
                <div className='field-section'>
                    <div className='field-row'>
                        <StreetAddressField />
                        <StreetAddress2Field />
                    </div>
                    <div className='field-row'>
                        <CityField />
                        <StateField />
                        <ZipCodeField />
                    </div>
                </div>
            </ShowIf>
        </>
    );
};
